export default {
  forgot_password_confirm: {
    title: 'Reset password',
    required_code: 'Code is required',
    required_password: 'Password is required',
    max_length_16: 'Password must be 8-16 characters',
    no_blank: 'Please enter alphanumeric characters or symbols only.',
    no_password_match: 'Password does not match',
    reset_password: 'Reset Password',
    caution: 'Please do not close this window',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'An email has been sent to the email address. Please enter the verification code sent to your email below.',
    verification_code: 'Verification Code',
    mail_send_code: 'Code sent in email',
    password: 'Password',
    new_password: 'New Password',
    password_display: 'Show password',
    password_no_display: 'Hide password',
    password_check: 'New Password (Confirm)',
    submit: 'Confirm',
  },
}
